import { defineComponent, ref, withKeys } from 'vue';
import { IGetGoodsListRes, IGetGoodsListReq, ICategoryListRes } from '@/api/goods-service/type.d';
import { useList } from '@/hooks/use-list';
import { getEsGoodsList, delEsGoods, getProductCategoryListAll } from '@/api/goods-service/index';
import { GOOSD_SERVICE_GOODS_STATE_LIST } from '@/constant';
import { ElMessage, ElMessageBox } from 'element-plus';
import useSupplierList from './useSupplierList';
import CustomTable from '@/components/custom-table/index';
import { renderColumns } from './tableData';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {
    CustomTable,
  },
  setup() {
    const {
      getSupplierListByQuery,
      supplierList,
      supplierLoading,
      supplierParamsKey,
      supplierParamsList,
    } = useSupplierList();
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<IGetGoodsListRes, IGetGoodsListReq>({
      request: {
        api: getEsGoodsList,
        params: {
          commodityCode: '',
          supplierIds: [],
          categoryIds: [],
          productName: '',
          pageNum: 1,
          pageSize: 10,
        },
        handleParams(paramsObj) {
          return paramsObj;
        },
      },
    });
    const cates = ref<Array<ICategoryListRes>>([]);
    const selectionIds = ref<Array<string>>([]);
    const tableEl = ref<any>(null);
    // 获取分类
    const getCates = async () => {
      try {
        const { data } = await getProductCategoryListAll();
        const formatCate = (arr: ICategoryListRes[]) => {
          arr.forEach((v) => {
            if (v.children?.length) {
              formatCate(v.children);
            } else {
              delete v.children;
            }
          });
        };
        formatCate(data);
        cates.value = data;
        console.log(data);
      } catch (error) {
        console.log('获取分类失败', error);
      }
    };
    const handleSelectionChange = (rows: IGetGoodsListRes['list']) => {
      selectionIds.value = rows.map(v => v.spuId);
    };
    const handleDelItem = async (spuIds: string[]) => {
      try {
        await ElMessageBox.confirm('请确认是否删除？', '提示');
        await delEsGoods(spuIds.map(v => v));
        ElMessage.success('操作成功');
        handleSearch(params.value.pageNum);
      } catch (error) {
        console.log('删除失败', error);
      }
    };
    handleSearch();
    getCates();

    const permissionConfig = usePermissionConfig();

    return {
      getSupplierListByQuery,
      supplierList,
      supplierLoading,
      tableEl,
      cates,
      handleSelectionChange,
      selectionIds,
      handleDelItem,
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      GOOSD_SERVICE_GOODS_STATE_LIST,
      supplierParamsKey,
      supplierParamsList,
      permissionConfig,
    };
  },
  render() {
    const slots = {
      fheader: () => (
        <el-form
          size="default"
          onKeyup={withKeys(() => this.handleSearch(), ['enter'])}
          label-width="130px"
        >
          <el-form-item
            label="供应商名称"
            label-width="130px"
            v-slots={{
              label: () => (
                <el-select
                  placeholder="选择类型"
                  v-model={this.supplierParamsKey}
                  style="margin-right:-12px"
                >
                  {this.supplierParamsList.map(item => (
                    <el-option key={item.value} label={item.label} value={item.value}></el-option>
                  ))}
                </el-select>
              ),
              default: () => (
                <el-select
                  placeholder="请输入供应商名称/编码"
                  clearable
                  multiple
                  filterable
                  remote
                  reserve-keyword
                  remote-method={this.getSupplierListByQuery}
                  loading={this.supplierLoading}
                  v-model={this.params.supplierIds}
                  class="select-full"
                >
                  {this.supplierList.map(item => (
                    <el-option
                      key={item.supplierId}
                      label={item.supplierName}
                      value={item.supplierId}
                    ></el-option>
                  ))}
                </el-select>
              ),
            }}
          ></el-form-item>
          <el-form-item label="商品名称">
            <el-input placeholder="请输入商品名称" v-model={this.params.productName} clearable />
          </el-form-item>
          <el-form-item label="商品类目">
            <el-cascader
              props={{
                expandTrigger: 'hover',
                checkStrictly: false,
                emitPath: false,
                multiple: true,
                lazy: false,
              }}
              clearable
              v-model={this.params.categoryIds}
              options={this.cates}
              collapse-tags
              show-all-levels={false}
              style="width:100%"
            />
          </el-form-item>
          <el-form-item label="SPU编码">
            <el-input
              class="input-with-select"
              placeholder="请输入关键词"
              v-model={this.params.commodityCode}
              clearable
            />
          </el-form-item>
          <el-form-item label-width="0" class="margin-left-20">
            <el-button type="primary" size="default" onClick={() => this.handleSearch()}>
              查询
            </el-button>
            <el-button size="default" onClick={this.handleReset}>
              重置
            </el-button>
          </el-form-item>
        </el-form>
      ),
      header: () => (
        <div>
          <el-button
            disabled={this.selectionIds.length === 0}
            size="default"
            type="danger"
            onClick={() => this.handleDelItem(this.selectionIds)}
          >
            批量删除
          </el-button>
        </div>
      ),
      main: ({ height }: any) => (
        <custom-table
          size="medium"
          data={this.tableData}
          columns={renderColumns(
            this.handleDelItem,
            this.$filters,
            this.$has(this.permissionConfig.DELETE),
          )}
          height={height}
          key={height}
          v-loading={this.tableLoading}
          onSelectionChange={this.handleSelectionChange}
        />
      ),
      ffooter: () => (
        <el-row style="width: 100%;padding-top:10px" type="flex" justify="end">
          <pagination
            total={this.tableTotal}
            current-page={this.params.pageNum}
            size={this.params.pageSize}
            onCurrentChange={this.handleCurrentChange}
            onSizeChange={this.handleSizeChange}
            page-sizes={[10, 20, 30, 50, 100, 200]}
          ></pagination>
        </el-row>
      ),
    };
    return (
      <div class="error-logs">
        <app-page v-slots={slots} />
      </div>
    );
  },
});
